<template>
    <div>
        <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i class="fa fa-align-justify"></i>
              <div class="card-header-actions">
              </div>
            </div>
            <b-list-group>
              <b-list-group-item v-for="(item, index) in items.sort()" :key="index">{{ item }}</b-list-group-item>             
            </b-list-group>
          </b-card>
    </div>
</template>

<script>

import axios from "axios";

export default {
  name: "PrinterComponent",
  data() {
    return {
      items: [] 
    }
  },
  methods: {
    async refreshData() {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        
        await axios.get(
            this.$store.state.ws_url + "/utils/printer/list"
        ).then(function(resp) {
            s.items = resp.data.obj;
        })
        .catch(function(error) {
            console.log(error);
        });
       
    }
   
  },
  mounted: function() {
    this.refreshData()
  }
  
};

</script>
